import { StatisticValueStatusEnum } from '../../enums';

export interface IStatisticSchema {
    value: string;
    difference: number | string;
    valueStatus: StatisticValueStatusEnum;
    differenceStatus: StatisticValueStatusEnum;
}
